import {
    SIM_PROVIDER_ACCOUNT_DELETE_OPEN_MODAL,
    SIM_PROVIDER_ACCOUNT_DELETE_REQUEST,
    SIM_PROVIDER_ACCOUNT_DELETE_RESULT
} from 'Redux/actionTypes';

export const simProviderAccountsDeleteOpenModal = (open, data) => ({
    type: SIM_PROVIDER_ACCOUNT_DELETE_OPEN_MODAL,
    payload: { open, data }
})
export const simProviderAccountsDeleteRequest = (data) => ({
    type: SIM_PROVIDER_ACCOUNT_DELETE_REQUEST,
    payload: data
})
export const simProviderAccountsDeleteResult = (data) => ({
    type: SIM_PROVIDER_ACCOUNT_DELETE_RESULT,
    payload: data
})

